import type {
  BroadcastListItem,
  BroadcastListResponse,
  SendBroadcastRequest,
} from '@shared/types';
import { api } from './api';

function toQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}

export interface ListBroadcastsParams {
  page?: number;
  limit?: number;
}

export async function listBroadcasts(
  params: ListBroadcastsParams = {}
): Promise<BroadcastListResponse> {
  const qs = toQuery({
    page: params.page ?? 1,
    limit: params.limit ?? 20,
  });
  return api<BroadcastListResponse>(`/admin/broadcasts${qs}`);
}

export async function sendBroadcast(
  body: SendBroadcastRequest
): Promise<BroadcastListItem> {
  return api<BroadcastListItem>('/admin/broadcasts', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
